import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { MapPin, Phone, Calendar, Shield, Truck, UserCheck } from 'lucide-react';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-229">
      <Header data-id="element-230" />

      <main data-id="element-231">
        <Hero data-id="element-232" />

        {/* Trust Bar */}
        <div className="bg-slate-900 py-12" data-id="element-233">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
            <div className="flex flex-wrap justify-center md:justify-between items-center gap-8 opacity-80 text-white font-bold tracking-widest uppercase text-xs" data-id="element-235">
              <div className="flex items-center" data-id="element-236">
                <Shield className="w-4 h-4 mr-2 text-blue-400" data-id="element-237" /> NCDOT
                Certified
              </div>
              <div className="flex items-center" data-id="element-238">
                <Shield className="w-4 h-4 mr-2 text-blue-400" data-id="element-239" /> ADA Compliant
              </div>
              <div className="flex items-center" data-id="element-240">
                <Shield className="w-4 h-4 mr-2 text-blue-400" data-id="element-241" /> HIPAA
                Compliant
              </div>
              <div className="flex items-center" data-id="element-242">
                <Shield className="w-4 h-4 mr-2 text-blue-400" data-id="element-243" /> Fully Insured
              </div>
            </div>
          </div>
        </div>

        <Services data-id="element-244" />

        <About data-id="element-245" />

        {/* Quick Features - Inspired by Gozie's layout */}
        <section className="py-24 bg-white" data-id="element-246">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
            <div className="grid md:grid-cols-3 gap-12" data-id="element-248">
              <div className="text-center" data-id="element-249">
                <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-250">
                  <Truck className="w-10 h-10 text-blue-600" data-id="element-251" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-252">Modern Fleet</h3>
                <p className="text-slate-600" data-id="element-253">
                  Equipped with state-of-the-art ramps and securement systems.
                </p>
              </div>
              <div className="text-center" data-id="element-254">
                <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-255">
                  <UserCheck className="w-10 h-10 text-blue-600" data-id="element-256" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-257">Expert Drivers</h3>
                <p className="text-slate-600" data-id="element-258">
                  Background-checked and trained for compassionate care.
                </p>
              </div>
              <div className="text-center" data-id="element-259">
                <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-260">
                  <Calendar className="w-10 h-10 text-blue-600" data-id="element-261" />
                </div>
                <h3 className="text-xl font-bold mb-4" data-id="element-262">Easy Booking</h3>
                <p className="text-slate-600" data-id="element-263">
                  Flexible scheduling for one-way or round-trip rides.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-blue-600 relative overflow-hidden" data-id="element-264">
          <div className="absolute inset-0 opacity-10" data-id="element-265">
            <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-266" />
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/3 translate-y-1/3" data-id="element-267" />
          </div>

          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-268">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-269">
              Ready to Schedule Your Next Ride?
            </h2>
            <p className="text-blue-100 text-xl mb-12 max-w-2xl mx-auto" data-id="element-270">
              Experience the independence and dignity you deserve. Our
              professional team is standing by to assist with your
              transportation needs.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-271">
              <button className="bg-white text-blue-600 px-10 py-5 rounded-2xl font-bold text-xl hover:bg-blue-50 transition-all shadow-2xl flex items-center justify-center" data-id="element-272">
                <Calendar className="w-6 h-6 mr-2" data-id="element-273" />
                Book Online Now
              </button>
              <a href="tel:7040000000" className="bg-blue-700 text-white border-2 border-blue-500 px-10 py-5 rounded-2xl font-bold text-xl hover:bg-blue-800 transition-all flex items-center justify-center" data-id="element-274">
                <Phone className="w-6 h-6 mr-2" data-id="element-275" />
                Call (704) AMO-RIDE
              </a>
            </div>
          </div>
        </section>

        {/* Service Area Section */}
        <section id="area" className="py-24 bg-slate-50" data-id="element-276">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-277">
            <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-278">
              <div data-id="element-279">
                <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-sm font-bold mb-6" data-id="element-280">
                  <MapPin className="w-4 h-4 mr-2" data-id="element-281" />
                  Our Service Area
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-282">
                  Serving Charlotte and Beyond
                </h2>
                <p className="text-slate-600 text-lg mb-8 leading-relaxed" data-id="element-283">
                  We proudly serve Charlotte and the surrounding North Carolina
                  areas, helping our clients maintain their independence and
                  actively participate in community life, healthcare, and social
                  activities.
                </p>
                <ul className="grid grid-cols-2 gap-4" data-id="element-284">
                  {['Charlotte', 'Concord', 'Gastonia', 'Huntersville', 'Matthews', 'Rock Hill', 'Mint Hill', 'Pineville'].map(city => <li key={city} className="flex items-center text-slate-700 font-medium" data-id="element-285">
                      <div className="w-2 h-2 bg-blue-600 rounded-full mr-3" data-id="element-286" />
                      {city}
                    </li>)}
                </ul>
              </div>
              <div className="rounded-3xl overflow-hidden shadow-2xl h-[400px] relative" data-id="element-287">
                {/* Placeholder for a map or area visual */}
                <img src="https://images.unsplash.com/photo-1516738901171-8eb4fc13bd20?auto=format&fit=crop&q=80&w=1000" alt="Charlotte NC Area" className="w-full h-full object-cover" data-id="element-288" />
                <div className="absolute inset-0 bg-blue-900/20" data-id="element-289" />
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-290">
                  <div className="bg-white/90 backdrop-blur-sm p-6 rounded-2xl shadow-xl text-center max-w-xs" data-id="element-291">
                    <MapPin className="w-10 h-10 text-blue-600 mx-auto mb-4" data-id="element-292" />
                    <p className="font-bold text-slate-900" data-id="element-293">
                      Door-to-Door Service
                    </p>
                    <p className="text-sm text-slate-600" data-id="element-294">
                      We pick you up from your door and ensure you're safely
                      inside your destination.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-295" />
    </div>;
}